<template>
  <v-app>
    <div class="header-strip">
        <a :href="configStrings.clubWebsiteLink">
          <img src="./assets/logo.svg" height="48" width="32" class="logo" />
        </a>
        <h1>{{configStrings.productName}}</h1>
    </div>
    <header class="header" v-if="showHeader">
      
      
        <UserInfo class="user-info-container" v-if="$route.path === '/profile'"/>
        <div v-else>
        </div>
        
        
        <div class="mini-nav" v-if="ticketingRedirect">
          <ul v-if="miniNavTicketingEnabled">
            <li><a v-on:click="redirectToTicketing()" class="web-link">Return to Ticketing</a></li>
          </ul>
        </div>
        <div class="mini-nav" v-else-if="$route.path === '/profile'">
          <ul>
           {{configStrings.clubName}} Official Websites
            <li  v-for="site in configOfficialWebsites" :key="site.URL">
              <a :href="site.URL" class="web-link" :target="site.target">{{site.title}}</a>
            </li>
            
          </ul>
        </div>
        <div v-else>
        </div>
  
    </header>
    
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import Vue from 'vue'
//import Vuetify from 'vuetify'
import CognitoPlugin from './cognito-plugin.js'
import GlobalConfig from './globalConfig.js'
import VueCookie from 'vue-cookie'
import UserInfo from '@/components/UserInfo'

import Vuetify, {
  VApp, // required
  VAlert,
  VTabs,
} from 'vuetify/lib'

import { Ripple } from 'vuetify/lib/directives'

Vue.use(Vuetify, {
  components: {
    VApp,
    VAlert,
    VTabs,
  },
  directives: {
    Ripple
  }
})

Vue.use(CognitoPlugin)
Vue.use(GlobalConfig)
Vue.use(VueCookie)
Vue.use(require('vue-moment'));

export default {
  name: 'App',
  components: {
    UserInfo
  },
  data () {
    return {
      loggedIn: false,
      referrer: null,
      showHeader: false,
      ticketingRedirect: null,
      miniNavTicketingEnabled: false
    }
  },
  mounted () {
    // console.log(window.location.href)
    //check if logout was requested
    if(window.location.href.includes("/partner/logout")){
       this.$signOut();
       this.$router.push("/");
    }
    
    // simple referral tracking
    if(window.location.href.includes("referred=1")){ //if the user is referred from a partner site
      localStorage.referrer = document.referrer
    }

    if(!window.location.href.includes("cross-site")){ //if the URL does not conatin cross-site
      this.showHeader = true
    }

    var urlPieces = window.location.href.split("returnUrl=")
    const urlParams = new URLSearchParams(window.location.search);
    const returnUrl = decodeURIComponent(urlPieces[1]) //we take the whole string after this param as it could itself contain params and we want to keep them
    const responseType = urlParams.get('responseType');
    const sendToken = urlParams.get('sendToken');
    // console.log('returnUrl:', returnUrl)
    // console.log('responseType:', responseType)
    // console.log('sendToken:', sendToken)

    if(window.location.href.includes("returnUrl=")) { //if the user is referred from the StreamAMG payments site
      
      // console.log('returnUrl requested')
      var trustedSource = false
      this.configTrustedDomains.forEach(domain => {
        if(returnUrl.includes(domain)){
          trustedSource = true
          // console.log(domain, 'is trusted')
        } 
      });
      
      if(trustedSource === true) {
        // console.log('Trusted returnUrl set', returnUrl)
        localStorage.returnUrl = returnUrl
        if(sendToken == "false") {
          localStorage.suppressToken = "true"
        } else {
          localStorage.removeItem('suppressToken');
        }
        if(responseType == "post"){
          localStorage.responseType = "post"
        }else{
          localStorage.responseType = "get"
        }
      } else {
        console.log('returnUrl NOT from trusted domain')
      }
    } else {
      console.log('returnUrl NOT requested')
    }

    if(typeof localStorage.returnUrl != 'undefined'){
      if(localStorage.returnUrl.includes('ticket')){
        this.ticketingRedirect = localStorage.returnUrl
      } 
    }
    //Upon initial mount we check the authentication state
    // console.log('Access Check', 'route change')
      if(this.$getAuthenticatedUser() != null) {
        // console.log('Access Check', 'user authenticated')
        this.$getCurrentUserAttributes().subscribe((userData) => {
          //check if the user has completed their registration (mostly this will be Social Media Registrations, post linking of their account)
          // console.log('Access Check', 'checking registration is complete')
          // console.log('Access Check userDate', userData)
          
          var additionalRegistrationFields = [
          'address'
          ]

          var proceed = true
          
          if(this.configValues.accountRequestAddressOnFirstLogin === false ){
            // if the system is configured to not request address on first login we do nothing
          } else if('custom:address_skip' in userData ){
            // if they've previously skipped adding their address then (for now) we do nothing
          } else {
            // otherwise we do a check that they have populated their address yet
            additionalRegistrationFields.forEach(element => {
              if( element in userData){
                console.log('Found additional key', element)
              } else {
                console.log('NOT found additional key', element)
                proceed = false
              }
            });
          }
          
          if(window.location.href.includes("/auth/logout") || window.location.href.includes("/oauth2")){
            // then we let it through to the logout page
          } else if(proceed === true){
            // console.log('Access Check', 'All fields populated')
            this.loggedIn = true;
            //always force logged in users to their profile, unless they are already going there or the site is being accessed by a partner site
            if(this.showHeader === true){
              if(this.$route.name != 'profile'){
                this.$router.push("/profile");
              }
            }
          }else{
            // console.log('Access Check', 'additional fields NOT yet complete 1')
            this.loggedIn = false;
            this.$router.push("/complete-registration");
          }
        }, 
        (err)=> {
          // console.log('Access Check', 'Unable to load user profile, session may not be present.')
          this.loggedIn = false;
        });
      
      } else {
        // console.log('Access Check', 'no authenticated user present')
        this.loggedIn = false;
      } 
    
    
  },
  methods: {
    redirectToTicketing (){
      var redirectTo = localStorage.returnUrl
      localStorage.returnUrl = ''
      window.location = redirectTo
    }
  },
  watch: {
    '$route' (to) {
      //Upon each route change we check the authentication state

      // console.log('Access Check', 'route change')
      if(this.$getAuthenticatedUser() != null) {
        // console.log('Access Check', 'user authenticated')
        this.$getCurrentUserAttributes().subscribe((userData) => {
          //check if the user has completed their registration (mostly this will be Social Media Registrations, post linking of their account)
          // console.log('Access Check', 'checking registration is complete')
          // console.log('Access Check userDate', userData)
          
          var additionalRegistrationFields = [
          'address'  
          ]

          var proceed = true
          
          if(this.configValues.accountRequestAddressOnFirstLogin === false ){
            // if the system is configured to not request address on first login we do nothing
          } else if('custom:address_skip' in userData ){
            // if they've previously skipped adding their address then (for now) we do nothing
          } else {
            // otherwise we do a check that they have populated their address yet
            additionalRegistrationFields.forEach(element => {
              if( element in userData){
                // console.log('Found additional key', element)
                if(element === 'address'){ // Sometimes clubs set country in registration so we need to check first line 
                  // console.log('TYPEOF address', typeof userData.address)
                  if(!userData.address.includes('street_address')){
                    proceed = false
                  }
                }
              } else {
                console.log('NOT found additional key', element)
                proceed = false
              }
            });
          }

          
          if(window.location.href.includes("/auth/logout") || window.location.href.includes("/oauth2")){
            // then we let it through to the logout page
          } else if(proceed === true){
            // console.log('Access Check', 'All fields populated',this.$route.name )
            this.loggedIn = true;
            //always force logged in users to their profile, unless they are already going there
            if(this.$route.name != 'profile'){
              this.$router.push("/profile");
            }
            
          } else {
            // console.log('Access Check', 'additional fields NOT yet complete 2')
            this.loggedIn = false;
            this.$router.push("/complete-registration");
          }
        }, 
        (err)=> {
          // console.log('Access Check', 'Unable to load user profile, session may not be present.')
          this.loggedIn = false;
        });
      
      } else {
        console.log('Access Check', 'no authenticated user present')
        this.loggedIn = false;
      }
    }
  }
}
</script>

<style lang="scss">
  @import '/css/global.scss';
</style>

<style lang="scss" scoped>

  .header {
    position: relative;
    display: flex;
    flex-direction: column-reverse;
    justify-content: center;
    align-items: center;
    padding: 20px 20px 0;
    margin: 0 0 35px;
  }

  .header-strip {
    width: 100%;
    color: #fff;
    background-color: $primary-club;
    display:flex;
    align-items: center;
    justify-content:left;
    padding: 10px 25px 5px 25px;
  }

  .header-strip img{
    display: inline;
  }

  .header-strip h1{
    display: inline;
    margin-left: 20px;
    font-size: 1.5em;
  }

  .user-info-container {
    margin: 20px 0 0;
  }
  .cross-site-container {
    margin: 20px 0 0;
  }

  .button-home {
    display: none;
  }

  @media screen and (min-width: 700px) {
    .header {
      flex-direction: row;
      justify-content: space-between;
      padding: 48px 100px 48px;
    }

    .user-info-container {
      top: 43px;
      left: 20px;
      margin: 0;
    }

    .button-home {
      display: block;
    }
  }

  @media screen and (min-width: 1200px) {
    .header {
      padding: 48px 300px 48px;
    }
  }
  .mini-nav{
    width:250px;
  }
  .mini-nav li{
    list-style: none
  } 
  .web-link{
    padding: 0;
    margin: 0 2px 0 0;
    color: $primary-club;
    font-size: 12px;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
  .page-title{
    color: $primary-club;
    font-size: 44px;
    text-align: left;
  }
</style>
